import script from "./SchoolPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SchoolPage.vue?vue&type=script&setup=true&lang=js"

import "./SchoolPage.vue?vue&type=style&index=0&id=9b91e3e8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b91e3e8"]])

export default __exports__